/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { ReportingProvider, UserProvider, FileProvider } from 'src/app/providers';
import { CrmAlertComponent } from 'src/app/modules/orderformlib/components/crm-alert/crm-alert.component';

@Component({
  selector: 'app-tfa-modal',
  templateUrl: './tfa.modal.html',
  styleUrls: ['./tfa.modal.scss']
})

export class TfaModal implements OnInit, OnDestroy {
  @ViewChild('alert') alert: CrmAlertComponent;
  subject: Subject<boolean>;
  subscription: any;
  code: string;
  image: string;
  loading: boolean = false;

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private userProvider: UserProvider,
    private fileProvider: FileProvider,
  ) { }

  ngOnInit(): void {
    // Fix for when user clicks `ESC` instead of clicking, no Event was firing
    this.subscription = this.modalService.onHide.subscribe((reason: string) => {
      if (reason === 'esc')
        this.onCancel();
    });

    this.loadQrCode();
  }

  ngOnDestroy(): void {

  }

  onSubmit(): void {
    this.alert.hide();
    this.loading = true;
    this.userProvider.verifyCode(this.code)
      .subscribe(data => {
        this.loading = false;
        if(data.success){
          this.bsModalRef.hide();
          this.subject.next(true);
          this.subject.complete();
        }
        else {
          this.alert.showError(data.error.txt);
        }
      });
  }
  onCancel(): void {
    this.bsModalRef.hide();
    this.subject.next(false);
    this.subject.complete();
  }

  loadQrCode(): void {
    this.loading = true;
    this.userProvider.setUpTfa()
      .subscribe(data => {
        if(data.success){
          this.image = data.result.IMAGE;
        }
        this.loading = false;
      })
  }
}
